var map = {
	"./bfs/app/item-page/simple/metadata-representation-list/metadata-representation-list.component": [
		44080,
		"src_themes_bfs_app_item-page_simple_metadata-representation-list_metadata-representation-list-e11941"
	],
	"./custom/app/item-page/simple/metadata-representation-list/metadata-representation-list.component": [
		32890,
		"src_themes_custom_app_item-page_simple_metadata-representation-list_metadata-representation-l-dac313"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 89979;
module.exports = webpackAsyncContext;